import React from 'react';
import Button from 'housecall-ui/dist/library/Buttons/Button';
import { useDispatch, useSelector } from 'react-redux';
import { track } from 'components/Services/Analytics/AnalyticsService';
import { getAppEnabled } from 'resources/Organization/Apps/AppsData';
import { PROFIT_RHINO } from '../AppsData';

const ProfitRhinoButton = () => {
  const appEnabled = useSelector(getAppEnabled(PROFIT_RHINO));
  const dispatch = useDispatch();

  const handleTellMeMore = () => {
    dispatch(
      track('Click', {
        button_name: 'tell me more',
        app_name: 'profit_rhino',
        pathname: '/pro/apps/details/profit_rhino',
      })
    );

    Intercom('showNewMessage', 'Can you tell me more about Profit Rhino?');
  };

  return appEnabled ? (
    <Button variant="contained" color="primary" href="/app/price_book">
      View My Pricebook
    </Button>
  ) : (
    <Button variant="contained" color="primary" onClick={handleTellMeMore}>
      Tell Me More
    </Button>
  );
};

export default ProfitRhinoButton;
